import styled from 'styled-components';

export const SToastWrapper = styled.div`
    --toastify-color-error: ${({ theme }) => theme.color.error.main};
    --toastify-color-warning: ${({ theme }) => theme.color.warning.main};
    --toastify-color-success: ${({ theme }) => theme.color.success.main};

    .Toastify__toast--error {
        background-color: ${({ theme }) => theme.color.error.main};
    }
    .Toastify__toast--warning {
        background-color: ${({ theme }) => theme.color.warning.main};
    }
    .Toastify__toast--success {
        background-color: ${({ theme }) => theme.color.success.main};
    }
    .Toastify__toast-body {
        font-weight: bold;
        white-space: pre-line;
    }
`;
